var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmeyaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1364 10.4775L3 3L11.6023 9.02152L8.27595 11.5717L5.1364 10.4775ZM11.7648 13.2128L9.56137 20.7041L5.26435 14.4732L11.7648 9.4896V13.2128ZM14.4386 20.7041L12.2352 13.2128V9.4896L18.7357 14.4732L14.4386 20.7041ZM15.7238 11.5715L12.3977 9.02152L21 3L18.8636 10.4775L15.7238 11.5715Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmeyaIcon);
export default __webpack_public_path__ + "static/media/ameyaIcon.3c572ec60fa3bc8c55ad62340db84cd6.svg";
export { ForwardRef as ReactComponent };